import React from 'react';

import './Notification.scss';

const EXIT_DURATION_MS = 1600;

let messages = [];
let listeners = new Set();
let messageId = 0;

const publish = () => {
    listeners.forEach((listener) => listener([...messages]));
};

const markNotificationVisible = (id) => {
    messages = messages.map((item) => (
        item.id === id ? { ...item, visible: true } : item
    ));
    publish();
};

const dismissNotification = (id) => {
    if (!messages.some((item) => item.id === id)) {
        return;
    }

    messages = messages.map((item) => (
        item.id === id ? { ...item, exiting: true } : item
    ));
    publish();

    setTimeout(() => {
        messages = messages.filter((item) => item.id !== id);
        publish();
    }, EXIT_DURATION_MS);
};

export const showNotification = (message, durationMs = 8000) => {
    if (!message) {
        return;
    }

    messageId += 1;
    const id = messageId;
    messages = [...messages, { id, message, visible: false, exiting: false }];
    publish();

    requestAnimationFrame(() => {
        markNotificationVisible(id);
    });

    setTimeout(() => {
        dismissNotification(id);
    }, durationMs);
};

const useMessages = () => {
    const [list, setList] = React.useState(messages);
    React.useEffect(() => {
        listeners.add(setList);
        return () => listeners.delete(setList);
    }, []);
    return list;
};

export const NotificationHost = () => {
    const list = useMessages();

    if (list.length === 0) {
        return null;
    }

    return (
        <div className="lyriapay-notifications">
            {list.map(({ id, message, visible, exiting }) => (
                <div
                    key={id}
                    className={[
                        'lyriapay-notification',
                        visible && 'lyriapay-notification--visible',
                        exiting && 'lyriapay-notification--exiting',
                    ].filter(Boolean).join(' ')}
                >
                    {message}
                </div>
            ))}
        </div>
    );
};
